import _ from 'underscore';

export function getValueFromQueryString(queryString, key) {

    let arraySplitByAnd = queryString.split('&');

    let itemContainingKey = _.find(arraySplitByAnd, function (item) {
        return item.indexOf(key) >= 0;
    });

    if (itemContainingKey) {
        let indexOfEqualChar = itemContainingKey.indexOf('=') + 1;

        if (indexOfEqualChar > 0)
            return itemContainingKey.substring(indexOfEqualChar, itemContainingKey.length);
    }
    return "";
}

export function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}
export function convertTimeSlotToString(slotId) {
    switch (slotId.toString()) {
        case "1":
            return "Between 8 am and 6 pm";
        case "2":
            return "Between 8 am and 1 pm";
        case "3":
            return "Between 1 pm and 6 pm";
        default:
            return "Between 8 am and 6 pm";
    }
}


export function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export function extractIdentityObjectFromIdentifier(identifier) {
    let colonSeperatedIds = b64DecodeUnicode(identifier).split(":");
    if (colonSeperatedIds.length === 5)
        return {
            userName: colonSeperatedIds[0],
            userId: colonSeperatedIds[1],
            merchantId: colonSeperatedIds[2],
            jobId: colonSeperatedIds[3],
            passcode: colonSeperatedIds[4]
        };
}



// WEBPACK FOOTER //
// ./app/util/sharedFunctions.js